<template>
  <Section id="workflow" tone="default" pad-y="xl" aria-labelledby="workflow-heading">
    <Container>
      <div class="mb-10 flex flex-col gap-3">
        <h2 id="workflow-heading" class="text-3xl font-bold text-ink-strong md:text-4xl">
          {{ t('sections.workflow.title') }}
        </h2>
        <p class="max-w-2xl text-base text-ink-muted md:text-lg">
          {{ t('sections.workflow.subtitle') }}
        </p>
      </div>
      <WorkflowStepper
        :steps="localizedSteps"
        :receives-label="t('sections.workflow.receivesLabel')"
      />
    </Container>
  </Section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Section from '@/components/primitives/Section.vue';
import Container from '@/components/primitives/Container.vue';
import WorkflowStepper from '@/components/domain/WorkflowStepper.vue';
import { WORKFLOW_STEPS, type WorkflowStepItem } from '@/content/home-data';
import { useLocale } from '@/composables/useLocale';
import { pickLocalized, pickLocalizedArray } from '@/lib/i18n/localize';

const { t } = useI18n();
const { locale } = useLocale();

const localizedSteps = computed<readonly WorkflowStepItem[]>(() =>
  WORKFLOW_STEPS.map((s) => ({
    ...s,
    title: pickLocalized(s, 'title', locale.value),
    subtitle: pickLocalized(s, 'subtitle', locale.value),
    receives: pickLocalizedArray(s, 'receives', locale.value),
  })),
);
</script>
